import Utils from '../common/Utils';
import Swiper from 'swiper';
import {GLOBAL_PATH, STORE } from '../common/Model';

export default class Shortcut {
	constructor(_config) {

		this.config = _config;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'shortcut',
			locale : this.config.locale,
			country : this.config.country
		};
		this.shortcutApiUrl = GLOBAL_PATH(_option);
		// console.log( '# shortcut.js this.shortcutApiUrl : ', this.shortcutApiUrl);
	}
	init() {
		if( Utils.isEmptyObject(STORE.data.shortcut) ) {
			this.get();
		} else {
			this.render(STORE.data.shortcut);
		}
	}

	get() {
		const _this =  this;
		fetch(this.shortcutApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.shortcut = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.shortcutApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.shortcut = _resData;
			this.render(_resData);
		});*/
	}
	render(data) {
		// console.log( '# shortcut.js render() data : ', data );
		const wrapper = document.querySelectorAll('#topShortcut, #bottomShortcut'); // $('.shortcut-wrapper');
		const tmpl = this.templ(data); // isActive:true 일 경우에만 렌더 하자
		if (data && data.isActive ) {
			wrapper.forEach( el => {
				el.innerHTML = tmpl;
			});
		}
		this.addEvent();
	}
	templ(_d){
		return `
			<ul class="shortcut-list swiper-wrapper isMobile">
			${_d.mobileList.map( (item, index) => {
				return this.mobileListTempl(item);
			}).join('')}
			</ul>
			<ul class="shortcut-list isPc">
			${_d.pcList.map( (item, index) => {
				return this.pcListTempl(item);
			}).join('')}
			</ul>`;
	}
	mobileListTempl(_a) {
		return `
			<li class="shortcut-item swiper-slide">
				<a href="${_a.url}"  ${_a.target ? 'target="_blank"' : ''}>${_a.title}</a>
			</li>`;
	}
	pcListTempl(_a) {
		return `
			<li class="shortcut-item">
				<a class="${_a.icontype}" href="${_a.url}" ${_a.target ? 'target="_blank"' : ''}>${_a.title}</a>
			</li>`;
	}

	addEvent() {
		// shortcut
		let topShortcutSwiper = new Swiper('#topShortcut', {
			slidesPerView: 'auto'
		});
		let bottomShortcutSwiper = new Swiper('#bottomShortcut', {
			slidesPerView: 'auto'
		});
	}

}